import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    VList,
    { class: _vm.listClass },
    [
      _c(_setup.ChangeLanguageButton, {
        on: {
          click: function ($event) {
            return _setup.emit("open-languages")
          },
        },
      }),
      _vm._v(" "),
      !_setup.hideTownSelect
        ? _c(_setup.SideMenuListItem, {
            attrs: {
              icon: "ui-icon-map-pin",
              "data-qa": "active_town",
              title: _setup.townTitle,
              "title-class": _setup.townTitleClass,
            },
            on: {
              click: function ($event) {
                return _setup.emit("open-town")
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _setup.isRealPatient || _setup.isAnonymous
        ? _c(VDivider, { attrs: { inset: "" } })
        : _vm._e(),
      _vm._v(" "),
      _setup.primaryUserItem
        ? _c(_setup.SideMenuListItem, {
            attrs: {
              icon: _setup.primaryUserItem.icon,
              href: _setup.primaryUserItem.href,
              title: _setup.primaryUserItem.label,
            },
          })
        : [
            _vm._l(_setup.guestAuthItems, function (item) {
              return _c(_setup.SideMenuListItem, {
                key: item.key,
                attrs: {
                  icon: item.icon,
                  "data-qa": item.qa,
                  title: item.label,
                },
                on: {
                  click: function ($event) {
                    item.onClick?.()
                  },
                },
              })
            }),
            _vm._v(" "),
            !_setup.isYDoc
              ? [
                  _c(VDivider, { attrs: { inset: "" } }),
                  _vm._v(" "),
                  _vm._l(_setup.expertItems, function (item) {
                    return _c(_setup.SideMenuListItem, {
                      key: item.key,
                      attrs: {
                        icon: item.icon,
                        "data-qa": item.qa,
                        title: item.label,
                      },
                      on: {
                        click: function ($event) {
                          item.onClick?.()
                        },
                      },
                    })
                  }),
                ]
              : _vm._e(),
          ],
      _vm._v(" "),
      _setup.isRealPatient
        ? [
            _c(_setup.ClubCardListItem, {
              on: {
                click: function ($event) {
                  return _setup.emit("click-card-info")
                },
              },
            }),
            _vm._v(" "),
            _vm._l(_setup.patientCabinetItems, function (item) {
              return _c(_setup.SideMenuListItem, {
                key: item.key,
                attrs: {
                  icon: item.icon,
                  href: item.href,
                  title: item.label,
                  subtitle: item.subtitle,
                  "subtitle-class":
                    item.key === "cabinet-medcard"
                      ? "text-body-2 error--text"
                      : "text-body-2 text-info--text",
                },
              })
            }),
            _vm._v(" "),
            _c(_setup.LogoutListItem, {
              on: {
                click: function ($event) {
                  return _setup.emit("logout")
                },
              },
            }),
          ]
        : _vm._e(),
      _vm._v(" "),
      _setup.isRealPatient || _setup.isAnonymous
        ? _c(VDivider, { attrs: { inset: "" } })
        : _vm._e(),
      _vm._v(" "),
      _setup.projects
        ? _c(_setup.SideMenuListItem, {
            attrs: {
              icon: "ui-icon-more-projects",
              "data-qa": "other_projects",
              title: _setup.projectsTitle,
            },
            on: {
              click: function ($event) {
                return _setup.emit("open-projects")
              },
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }